import { removeWhiteSpace } from '@/shared/utils/stringUtils'
import { Company } from '../../../shared/models/companyModel'
import {
    CreateMember,
    CreateMemberGateway,
    Member,
    UpdateMember,
    UpdateMemberGateway
} from '../../../shared/models/memberModel'
import { RequestResponse, requestService } from '../../../shared/services/requestServices'
import { resolveApiUrl } from '../../../shared/utils/requestsUtils'
import { trackEvent } from '../../../shared/utils/analyticsUtils'

export const deleteMemberService = async (
    companyId: Company['id'],
    id: Member['id']
): Promise<RequestResponse<Member> | undefined> => {
    const url = resolveApiUrl('member.delete', { variables: { companyId, id } })
    const response = await requestService<Member>(url, { method: 'DELETE' })

    trackEvent('Delete_Member')

    return response
}

export const createMemberService = async (
    companyId: Company['id'],
    payload: CreateMember
): Promise<RequestResponse<Member> | undefined> => {
    const { name, email, privileges } = payload

    const formattedPayload: CreateMemberGateway = {
        email: removeWhiteSpace(email),
        privileges,
        name
    }

    const url = resolveApiUrl('member.create', { variables: { companyId } })
    const response = await requestService<Member>(url, { method: 'POST', data: formattedPayload })

    trackEvent('Create_Member')

    return response
}

export const updateMemberService = async (
    companyId: Company['id'],
    payload: UpdateMember
): Promise<RequestResponse<Member> | undefined> => {
    const { id, name, email, privileges } = payload

    const formattedPayload: UpdateMemberGateway = {
        email: email ? removeWhiteSpace(email) : undefined,
        name,
        privileges
    }

    const url = resolveApiUrl('member.update', { variables: { companyId, id } })
    const response = await requestService<Member>(url, { method: 'PATCH', data: formattedPayload })

    trackEvent('Update_Member')

    return response
}
